import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Drawer from '@mui/material/Drawer';
import Drivers from './Drivers';
import Summary from './Summary';

const initialState = {
  drivers: [],
};

const AddDriversToLocationWizard = ({ onClose, openDrawer }) => {
  const [step, setStep] = useState(1);
  const [driverState, setDriverState] = useState(initialState);
  const next = () => setStep(R.inc);
  const prev = () => setStep(R.dec);

  const reset = () => {
    setDriverState(initialState);
    prev();
  };

  return (
    <Drawer anchor="right" onClose={onClose} open={openDrawer}>
      {step === 1 && (
        <Drivers
          driverState={driverState}
          next={next}
          onClose={onClose}
          prev={prev}
          setDriverState={setDriverState}
        />
      )}
      {step === 2 && (
        <Summary driverState={driverState} onClose={onClose} prev={prev} reset={reset} />
      )}
    </Drawer>
  );
};

AddDriversToLocationWizard.propTypes = {
  onClose: PropTypes.func.isRequired,
  openDrawer: PropTypes.bool,
};
AddDriversToLocationWizard.defaultProps = {
  openDrawer: false,
};

export default AddDriversToLocationWizard;
